import { IconButton } from "@mui/material";
import IPassword, { IKeyVal } from "../shared/Password";
import useConfirm from "./dialogs/Confirm";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import PassApi from "../data/PassApi";
import { ChevronRightOutlined, DeleteOutline, EditOutlined, SaveOutlined } from "@mui/icons-material";
import PropertyListEdit from "./PropertyListEdit";
import { useState } from "react";
import PropertyList from "./PropertyList";
import PassUtils from "../data/PassUtils";
import Utils from "../libs/Utils";

export default function PasswordRow(props:{password:IPassword}) {
    const {password} = props
    const [open,setOpen] = useState<boolean>(false)
    const [edit,setEdit] = useState<boolean>(false)
    const [dirty,setDirty] = useState<boolean>(false)
    const [data,setData] = useState<IKeyVal[]>(password.data.map(keyval => ({key:keyval.key,val:keyval.val})))
    const {confirm} = useConfirm()
    const {setSnackbar} = useSnackbar()

    const onConfirmDelete = async () => {
        try {
            await PassApi.i.delete(password.id)
        }catch(e){
            setSnackbar(e)
        }
    }
    const onDelete = () => confirm(`Are you sure you wish to delete ${password.name}`, onConfirmDelete)
    const checkDirty = () => setDirty(JSON.stringify(data)!=JSON.stringify(password.data))
    const onUpdateProp = (index:number,key:string,val:string) => {
        if (index<0) {
            if (key||val) setTimeout(() => {
                const current = document.activeElement
                let id = current?.id
                if (current && id && current.tagName=="INPUT") {
                    const {type, index, passwordId:passId} = PassUtils.fromInputId(id)
                    if (!index && passId==password.id) id = PassUtils.toInputId(type, passId, data.length)
                    setTimeout(() => (document.querySelector("#"+id) as HTMLInputElement)?.focus())
                }
                setData([...data, {key,val}])
            })
        }
        else {
            data[index] = {key,val}
            setData([...data])
        }
        checkDirty()
    }
    const onDeleteProp = async (index:number) => {
        data.splice(index, 1)
        setData([...data])
        setDirty(true)
    }
    const onSave = async () => {
        try {
            checkDirty()
            await Utils.sleep(1)
            if (dirty) {
                const filtered = data.filter(r => !!r.key)
                await PassApi.i.update(password.id, filtered)
                setData(filtered)
            }
            setEdit(false)
            return true
        }catch(e){
            setSnackbar(e)
            return false
        }
    }
    const onDirty = () => setDirty(true)
    const onEdit = () => {
        if (!open) setOpen(true)
        setEdit(true)
    }
    const toggle = async () => {
        if (open && edit) onSave()
        else setOpen(!open)        
    }
    const className = "row" + (open ? " open" : "")
    const propertyList = open ? 
        (edit ? <PropertyListEdit passwordId={password.id} data={data} onUpdate={onUpdateProp} onDelete={onDeleteProp} onDirty={onDirty}/> : <PropertyList data={data}/>)
        : null
    return <div className={className}>
        <div className="name flex middle" key={password.id}>
            <div className="name flex1" onClick={toggle}>{password.name}</div>
            {edit ? null : <IconButton onClick={onEdit}><EditOutlined/></IconButton>}
            {edit ? <IconButton onClick={onSave} disabled={!dirty}><SaveOutlined/></IconButton> : null}
            <IconButton onClick={onDelete}><DeleteOutline/></IconButton>
            <IconButton onClick={toggle} className="arrow"><ChevronRightOutlined/></IconButton>
        </div>
        {propertyList}
    </div>
}
    